module.exports = __webpack_public_path__ + "img/georeference.4bf3fdd2.svg";